<template>
  <el-button @click="exportExcel" size="mini" type="success" class="but">{{
    $t("lang.xlsx.export")
  }}</el-button>
</template>

<script>
//导出xlsx文件
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  props:['wait'],
  methods: {
    exportExcel() {
      this.$emit("exportExcel");
      if(this.wait) return;
      /* generate workbook object from table */
      let wb;
      let fix = document.querySelector(".el-table__fixed");
      let index = document.getElementsByClassName("index");
      let table = document.querySelector("#out-table");
      let indexs = document.getElementsByClassName("indexs");
      //判断是否存在.el-table__fixed  .el-table__fixed的存在导致导出表格会重复导出一次数据
      if (fix) {
        //.el-table__fixed存在，导出时删除dom节点
        table.removeChild(fix);
        //删除序列号索引
        for (let i = 0; i < indexs.length; i++) {
          if (index.length > 0) {
            indexs[i].removeChild(index[0]);
          }
        }
        wb = XLSX.utils.table_to_book(table, {
          cellDates: true,
        });
        //加入dom
        document.querySelector("#out-table").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          cellDates: true,
        });
      }
      for (const item in wb.Sheets.Sheet1) {
        if (wb.Sheets.Sheet1[item].z == "m/d/yy") {
          wb.Sheets.Sheet1[item].z = "";
          wb.Sheets.Sheet1[item].t = "s";
          wb.Sheets.Sheet1[item].v = this.dataFormDate(
            wb.Sheets.Sheet1[item].v
          );
        }
      }
      /* get binary string as output */
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
        cellDates: true,
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "index.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    exportExcel2(){
      let wb;
      let fix = document.querySelector(".el-table__fixed");
      let index = document.getElementsByClassName("index");
      let table = document.querySelector("#out-table");
      let indexs = document.getElementsByClassName("indexs");
      //判断是否存在.el-table__fixed  .el-table__fixed的存在导致导出表格会重复导出一次数据
      if (fix) {
        //.el-table__fixed存在，导出时删除dom节点
        table.removeChild(fix);
        //删除序列号索引
        for (let i = 0; i < indexs.length; i++) {
          if (index.length > 0) {
            indexs[i].removeChild(index[0]);
          }
        }
        wb = XLSX.utils.table_to_book(table, {
          cellDates: true,
        });
        //加入dom
        document.querySelector("#out-table").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          cellDates: true,
        });
      }
      for (const item in wb.Sheets.Sheet1) {
        if (wb.Sheets.Sheet1[item].z == "m/d/yy") {
          wb.Sheets.Sheet1[item].z = "";
          wb.Sheets.Sheet1[item].t = "s";
          wb.Sheets.Sheet1[item].v = this.dataFormDate(
            wb.Sheets.Sheet1[item].v
          );
        }
      }
      /* get binary string as output */
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
        cellDates: true,
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "index.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    dataFormDate(date) {
      return `${date.getFullYear()}-${
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      }-${date.getDate() < 10 ? "0" + date.getDate() : date.getDate()} ${
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      }:${
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      }:${
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      }`;
    },
  },
};
</script>

<style scoped>
.but {
  margin-right: 0.2rem;
}
</style>
